export function nullIfEmpty(value: string | null | undefined): string | null {
  if (value === undefined || value === null || value.trim() === '') {
    return null
  }
  return value
}
